import React, { useState } from 'react';

const TestDocumentUpload = () => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploadStatus, setUploadStatus] = useState('');
  const [documents, setDocuments] = useState([]);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    console.log('File selected:', file);
    
    if (file) {
      setSelectedFile(file);
      setUploadStatus(`Selected: ${file.name} (${(file.size / 1024 / 1024).toFixed(2)} MB)`);
    }
  };

  const handleUpload = () => {
    if (!selectedFile) {
      setUploadStatus('Please select a file first');
      return;
    }

    setUploadStatus('Uploading...');
    
    // Simulate upload
    setTimeout(() => {
      const newDoc = {
        id: Date.now(),
        name: selectedFile.name,
        size: selectedFile.size,
        type: selectedFile.type,
        uploadedAt: new Date().toLocaleString()
      };
      
      setDocuments(prev => [...prev, newDoc]);
      setUploadStatus('Upload successful!');
      setSelectedFile(null);
      
      // Clear the input
      document.getElementById('test-file-input').value = '';
    }, 1000);
  };

  return (
    <div style={{ padding: '20px', maxWidth: '600px', margin: '0 auto' }}>
      <h2>🧪 Test Document Upload</h2>
      
      <div style={{ 
        border: '2px dashed #ccc', 
        padding: '20px', 
        textAlign: 'center',
        marginBottom: '20px',
        borderRadius: '8px'
      }}>
        <input
          type="file"
          id="test-file-input"
          accept=".jpg,.jpeg,.png,.pdf"
          onChange={handleFileChange}
          style={{ marginBottom: '10px' }}
        />
        <br />
        <button 
          onClick={handleUpload}
          disabled={!selectedFile}
          style={{
            padding: '10px 20px',
            backgroundColor: selectedFile ? '#007bff' : '#ccc',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: selectedFile ? 'pointer' : 'not-allowed'
          }}
        >
          Upload File
        </button>
      </div>

      {uploadStatus && (
        <div style={{ 
          padding: '10px', 
          backgroundColor: uploadStatus.includes('successful') ? '#d4edda' : '#f8f9fa',
          border: '1px solid #ccc',
          borderRadius: '4px',
          marginBottom: '20px'
        }}>
          {uploadStatus}
        </div>
      )}

      <div>
        <h3>Uploaded Documents ({documents.length})</h3>
        {documents.length === 0 ? (
          <p>No documents uploaded yet</p>
        ) : (
          <ul>
            {documents.map(doc => (
              <li key={doc.id} style={{ marginBottom: '10px', padding: '10px', backgroundColor: '#f8f9fa', borderRadius: '4px' }}>
                <strong>{doc.name}</strong><br />
                <small>Size: {(doc.size / 1024 / 1024).toFixed(2)} MB | Type: {doc.type} | Uploaded: {doc.uploadedAt}</small>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

export default TestDocumentUpload;